module.exports = __webpack_public_path__ + "media/images/front/varieties/CLEMENRUBI-d02a32045836a4adce5f4d92bcb4b421.jpg";